import { Alert } from 'antd';
import { useGetArticleContentQuery } from 'services';

import CommiteeDecisionForm from './CommitteeDecisionForm';

/**
 * İH - Madde Kontrol aşamasında "Tercüme'ye Gönder" karar ekranı. Yalnız yabancı yazarlı maddelerde
 * açılır; karar gönderildiğinde madde İH - Tercüme aşamasına geçer.
 *
 * Madde dosyası ortak karar formunun içindeki yükleme bloğundan gelir ve kendi isteğiyle kaydedilir;
 * bu ekran yalnız dosyanın varlığını denetler — dosyasız tercüme gönderimi engellenir.
 *
 * @param {number} offerID Madde teklifi ID'si.
 * @param {number} step Maddenin süreç adımı.
 * @param {number} status Gönderilecek heyet kararı kodu.
 */
const SendToTranslationDecision = ({ offerID, step, status }) => {
  const { data } = useGetArticleContentQuery({ offerID }, { skip: !offerID });

  const hasItemFile = Boolean(data?.contents?.find((content) => content.type === 0)?.media?.length);

  return (
    <CommiteeDecisionForm
      offerID={offerID}
      step={step}
      status={status}
      isSubmitDisabled={!hasItemFile}
    >
      <Alert
        className="gx-mb-4"
        type="info"
        showIcon
        message="Tercüme'ye Gönder"
        description="Madde İH - Tercüme aşamasına geçecek ve tercümesi tamamlanmış hâliyle bu aşamaya geri dönecek. Mevcut madde dosyası olduğu gibi taşınır; yeni bir dosya yüklerseniz maddenin yeni sürümü olarak kaydedilir, önceki sürüm silinmez."
      />
    </CommiteeDecisionForm>
  );
};

export default SendToTranslationDecision;
